import { graphql } from '../../gql';

export const GET_AKTIVIERUNG = graphql(`
  query E2nApiGetAktivierung {
    aktivierung {
      __typename
      ... on Aktivierungszustand {
        aktiv
        gesperrt
      }
    }
  }
`);

export const GET_VERTRAEGE = graphql(`
  query E2nApiGetVertraege {
    aktivierung {
      __typename
      ... on Aktivierungszustand {
        vertraege {
          vertragsnummer
          kundennummer
          unternehmensname
        }
      }
    }
  }
`);

export const GET_ZUGAENGE = graphql(`
  query E2nApiGetZugaenge {
    zugaenge {
      __typename
      ... on ZugangQuerySuccess {
        zugangLimit
        zugaenge {
          uid
          aktiv
          apiKey
          beschreibung
          partnerTemplate {
            anzeigename
            beschreibung
          }
          endpunktDefinitionen {
            endpunktName
            httpMethode
            attribute
          }
        }
      }
    }
  }
`);

export const GET_KATALOG = graphql(`
  query E2nApiGetKatalog {
    katalog(profil: STANDARD) {
      name
      anzeigename
      beschreibung
      gruppe
      httpMethode
      attribute {
        name
        beschreibung
        typ
      }
    }
  }
`);
